export const DISPUTE_STATUS_OPEN = 'dispute.open';
export const DISPUTE_STATUS_CLOSED = 'dispute.closed';